import { Component, ViewChild, enableProdMode} from '@angular/core';
import { Nav, Platform} from 'ionic-angular';
// import { StatusBar } from '@ionic-native/status-bar';
// import { SplashScreen } from '@ionic-native/splash-screen';

import { ShareServicesProvider } from '../providers/share-services/share-services';
import { ShareUiProvider } from '../providers/share-ui/share-ui';


// import { HomePage } from '../pages/home/home';
// import { ListPage } from '../pages/list/list';
//
enableProdMode();

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage: any = 'LoginPage';
  pages: Array<{ title: string, component: any }>;
  langID:any;
  isLogin: any = false;

  constructor(
    public platform: Platform,
    // public statusBar: StatusBar,
    // public splashScreen: SplashScreen,
    public shareServices: ShareServicesProvider,
    public shareUi: ShareUiProvider
  ) {
    if(this.shareServices.getToken()) this.isLogin = true;
    //
    this.shareServices.checkLang();
    this.langID = this.shareServices.lang;
    //
    this.shareServices.getLabel().subscribe(data => {
      this.shareServices.label = data.label;
      this.shareServices.menu = data.menu;
    },
    err => {
      this.shareUi.showAlert('',err);
    }, () => {
      //on complete
      //
      if (!this.shareServices.menu[this.langID]) return;
      this.pages = [
        { title: this.shareServices.menu[this.langID].home, component: 'HomePage' },  
        { title: this.shareServices.menu[this.langID].status, component: 'SignupStatusPage' },        
        { title: this.shareServices.menu[this.langID].history, component: 'HistoryPage' },
        { title: this.shareServices.menu[this.langID].profile, component: 'ProfilePage' },
        { title: this.shareServices.menu[this.langID].changePassword, component: 'PasswordChangePage' }
      ];
    });
    //
    this.initializeApp();
  }

  openWeb(){
    window.location.href = "http://li.buu.ac.th"; 
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.nav.setRoot(page);
  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      // this.statusBar.styleDefault();
      // this.splashScreen.hide();
    });
  }

  signOut() : void {
    this.shareUi.loadingShow();
    const token = this.shareServices.getToken();
    this.shareServices.doSignOut(token).subscribe( data => {
      //sending
    },
    err => {
      this.shareUi.loadingHide();
      this.shareUi.showAlert('',err);
      //console.log(err);
    },() => {
      //on complete
      this.shareUi.loadingHide();
      //clear token
      this.shareServices.clearToken();
      //go to LoginPage
      this.nav.setRoot('LoginPage');
      this.isLogin= false;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts